import React, { Component } from 'react';
import './styles.scss';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import { ResponsiveMode } from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';
import { initializeIcons } from "@uifabric/icons";

class DropdownField extends Component {
  render() {
    let { options = [], onChange = () => { console.log('Function Called') }, inputValue = '', isDisabled = false, isError = false, errorMessage = "" ,  placeholder=false, shadow = false} = this.props;
    initializeIcons();
    return (
      <div className="dropdown-container">
        <Dropdown
          options={options}
          responsiveMode={ResponsiveMode.xLarge}
          defaultSelectedKey={inputValue}
          onChange={onChange}
          isDisabled={isDisabled}
          selectedKey={inputValue}
          errorMessage={isError ? errorMessage : undefined}
          styles={shadow ? { caretDown: { color: '#FAFBFD' }, callout: {boxShadow: '0px 3px, 0px -3px'} } : { caretDown: { color: '#FAFBFD' } }}
          placeholder={placeholder}
        />
      </div>
    );
  }
}

export default DropdownField;